import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

const QuickActions = () => {
  const navigate = useNavigate();

  const actions = [
    { label: 'View All Bookings', path: '/admin/bookings' },
    { label: 'Manage Vendors', path: '/admin/vendors' },
    { label: 'View Analytics', path: '/admin/analytics' },
    { label: 'Payment History', path: '/admin/payments' }
  ];

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 sm:p-6">
      <h3 className="text-sm font-semibold text-gray-900 mb-4">Quick Actions</h3>
      <div className="space-y-2">
        {actions.map((action) => (
          <button
            key={action.path}
            onClick={() => navigate(action.path)}
            className="w-full flex items-center justify-between p-3 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors text-sm"
          >
            <span className="font-medium text-gray-900">{action.label}</span>
            <ArrowUpRight className="w-4 h-4 text-gray-400" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;

